// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2rXz7","colMaxWidth":"Table_colMaxWidth__2EzHt"};